import { useEffect, useState } from "react";

export default function useScheduleEmployees({
  db,
  collection,
  getDocs,
  getEmployeeName,
}) {
  const [employees, setEmployees] = useState([]);
  const [employeeById, setEmployeeById] = useState(new Map());

  useEffect(() => {
    let cancelled = false;

    async function loadEmployees() {
      try {
        const snap = await getDocs(collection(db, "users"));
        if (cancelled) return;

        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        const filtered = list.some((x) => "active" in x)
          ? list.filter((x) => x.active !== false)
          : list;

        filtered.sort((a, b) =>
          String(getEmployeeName(a)).localeCompare(String(getEmployeeName(b)))
        );

        setEmployees(filtered);

        const byId = new Map();
        for (const e of filtered) byId.set(e.id, e);
        setEmployeeById(byId);
      } catch (e) {
        console.warn("ScheduleBoard: users collection not readable:", e?.message || e);
        setEmployees([]);
        setEmployeeById(new Map());
      }
    }

    loadEmployees();

    return () => {
      cancelled = true;
    };
  }, [db, collection, getDocs, getEmployeeName]);

  return {
    employees,
    employeeById,
    setEmployees,
    setEmployeeById,
  };
}